"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceElevator = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var SpaceElevator = (function (_super) {
    __extends(SpaceElevator, _super);
    function SpaceElevator() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.SPACE_ELEVATOR,
            tags: [Tags_1.Tags.SPACE, Tags_1.Tags.BUILDING],
            cost: 27,
            productionBox: Units_1.Units.of({ titanium: 1 }),
            metadata: {
                cardNumber: '203',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 1 steel to gain 5 M€.', function (eb) {
                        eb.steel(1).startAction.megacredits(5);
                    }).br;
                    b.production(function (pb) { return pb.titanium(1); });
                }),
                description: 'Increase your titanium production 1 step.',
                victoryPoints: 2,
            },
        }) || this;
    }
    SpaceElevator.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        return undefined;
    };
    SpaceElevator.prototype.canAct = function (player) {
        return player.steel > 0;
    };
    SpaceElevator.prototype.action = function (player) {
        player.steel--;
        player.megaCredits += 5;
        return undefined;
    };
    SpaceElevator.prototype.getVictoryPoints = function () {
        return 2;
    };
    return SpaceElevator;
}(Card_1.Card));
exports.SpaceElevator = SpaceElevator;
